import { Globe } from 'lucide-react';
import { useI18n, type UiLocale } from '../contexts/I18nContext';

interface LanguageSelectorProps {
  className?: string;
}

const LANGUAGE_OPTIONS: Array<{ value: UiLocale; label: string }> = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'zh', label: '中文' },
  { value: 'ru', label: 'Русский' },
];

export function LanguageSelector({ className = '' }: LanguageSelectorProps) {
  const { locale, setLocale, tt } = useI18n();

  return (
    <label className={`inline-flex items-center gap-2 text-theme-text-secondary ${className}`}>
      <Globe className="h-4 w-4" aria-hidden="true" />
      <span className="sr-only">{tt('Language')}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as UiLocale)}
        aria-label={tt('Language')}
        className="bg-theme-surface border border-theme-border-muted rounded-md px-2 py-1 text-xs sm:text-sm text-theme-text focus:outline-none focus:ring-2 focus:ring-accent-500/40"
      >
        {LANGUAGE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
